export const SET_MAP = 'SET.MAP';
export const SET_DISTANCE = 'SET.DISTANCE';
export const SET_SERVICE = 'SET.SERVICE';
export const SET_POS = 'SET.POS';
export const SET_CURRENT_DISTANCE = 'SET.CURRENT.DISTANCE';
export const SET_CURRENT_SERVICE = 'SET.CURRENT.SERVICE';
export const UNSET_CURRENT_SERVICE = 'UNSET.CURRENT.SERVICE';
export const RESET_CURRENT_SERVICE = 'RESET.CURRENT.SERVICE';
export const SET_CURRENT_LAT_LNG = 'SET.CURRENT.LAT.LNG';
export const SET_ACTIVE_TAB = 'SET.ACTIVE.TAB';
export const SET_MARKERS = 'SET.MARKERS';
export const SET_SEARCH = 'SET.SEARCH';
